export default "/images/SL_gauche.png?0420da52186df0f371c8f66250f0769d";